class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer) {
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
    setTimeout(function(){ HulkappWishlist.init(); }, 2000);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
        if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
    if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('ProductGridContainer').innerHTML;

    document
      .getElementById('ProductGridContainer')
      .querySelectorAll('.scroll-trigger')
      .forEach((element) => {
        element.classList.add('scroll-trigger--cancel');
      });
  }

  static renderProductCount(html) {
    const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML;
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    container.innerHTML = count;
    container.classList.remove('loading');
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    const facetDetailsElements = parsedHTML.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    };
    const facetsToRender = Array.from(facetDetailsElements).filter((element) => !matchesIndex(element));
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`).innerHTML = element.innerHTML;
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector('.facets__selected');
    const sourceElement = source.querySelector('.facets__selected');

    const targetElementAccessibility = target.querySelector('.facets__summary');
    const sourceElementAccessibility = source.querySelector('.facets__summary');

    if (sourceElement && targetElement) {
      target.querySelector('.facets__selected').outerHTML = source.querySelector('.facets__selected').outerHTML;
    }

    if (targetElementAccessibility && sourceElementAccessibility) {
      target.querySelector('.facets__summary').outerHTML = source.querySelector('.facets__summary').outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      },
    ];
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(event.target.closest('form'));
      this.onSubmitForm(searchParams, event);
    } else {
      const forms = [];
      const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            const noJsElements = document.querySelectorAll('.no-js-list');
            noJsElements.forEach((el) => el.remove());
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join('&'), event);
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf('?') == -1
        ? ''
        : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input').forEach((element) =>
      element.addEventListener('change', this.onRangeChange.bind(this))
    );
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('min', 0);
    if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);

//Custom Sort Filter
let fetchedHtml = null;

class CustomSortByFilter extends HTMLElement {
  constructor() {
    super();
    this.initializeVariables();
  }

  initializeVariables() {
    this.sortByFilterOpen = this.querySelector(".custom-sort-by-filter-btn");
    this.sortByFilterClose = this.querySelector(".custom-sort-by-close-btn");
    this.customSortByFilterContainer = this.querySelector(".custom-sort-by-filter-container");

    this.sortByFilterOpen.addEventListener("click", this.openFilter.bind(this));
    this.sortByFilterClose.addEventListener("click", this.closeFilter.bind(this));
    this.querySelectorAll("li").forEach(sortByListItem =>
      sortByListItem.addEventListener("click", this.handleSort.bind(this))
    );
  }

  addClassName(element) {
    if (element) element.classList.add("custom-filter-mobile-style-outline", "tw-text-primary");
  }

  removeClassName(element) {
    if (element) element.classList.remove("custom-filter-mobile-style-outline", "tw-text-primary");
  }

  openFilter() {
    this.customSortByFilterContainer.classList.add("show-popup");
    document.body.style.overflow = "hidden";

    this.removeClassName(document.querySelector(".custom-filter-mobile-style"));
    this.addClassName(this.sortByFilterOpen);

    if (fetchedHtml) {
      this.removeClassName(fetchedHtml.querySelector(".custom-filter-mobile-style"));
      this.addClassName(fetchedHtml.querySelector(".custom-sort-by-filter-btn"));
    } else {
      this.addClassName(document.querySelector(".custom-sort-by-filter-btn"));
      this.removeClassName(document.querySelector(".custom-filter-mobile-style"));
    }

    // Ensure the correct sort option is active
    const urlParams = new URLSearchParams(window.location.search);
    const activeSortValue = urlParams.get("sort_by");
    this.updateActiveSortOption(activeSortValue);
  }

  closeFilter() {
    this.customSortByFilterContainer.classList.remove("show-popup");
    document.body.style.overflow = "unset";
  }

  updateURL(url, sortValue) {
    const urlObj = new URL(url);
    urlObj.searchParams.set("sort_by", sortValue);
    return urlObj.toString();
  }

  handleSort(event) {
    const sortValue = event.currentTarget.dataset.sortValue;
    const updatedUrl = this.updateURL(window.location.href, sortValue);

    // Remove the active class from all list items
    this.querySelectorAll("li").forEach(sortByListItem =>
      sortByListItem.classList.remove("selected-sort-option")
    );

    // Add the active class to the clicked item
    event.currentTarget.classList.add("selected-sort-option");

    fetch(updatedUrl)
      .then(response => response.text())
      .then(result => {
        const resultData = document.createElement("div");
        resultData.innerHTML = result;

        const newFacets = resultData.querySelector(".facets-vertical");
        const currentFacets = document.querySelector(".facets-vertical");
        if (newFacets && currentFacets) {
          currentFacets.innerHTML = newFacets.innerHTML;
          fetchedHtml = currentFacets; // Update fetchedHtml globally

          // Update the active sort option
          this.updateActiveSortOption(sortValue);

          window.history.replaceState({}, "", updatedUrl);
          document.body.style.overflow = "unset";
        }
      })
      .catch(error => {
        console.error("Error fetching sorted content:", error);
      });
  }

  updateActiveSortOption(activeSortValue) {
    this.querySelectorAll("li").forEach(sortByListItem => {
      sortByListItem.classList.remove("selected-sort-option");
    });

    const activeSortOption = this.querySelector(`li[data-sort-value="${activeSortValue}"]`);
    if (activeSortOption) {
      activeSortOption.classList.add("selected-sort-option");
    }
  }
}

customElements.define("custom-sort-by-filter", CustomSortByFilter);

class CustomFilterFacet extends HTMLElement {
  constructor() {
    super();
    this.filterMobileClick();
  }

  addClassName(element) {
    if (element) element.classList.add("custom-filter-mobile-style-outline", "tw-text-white");
  }

  removeClassName(element) {
    if (element) element.classList.remove("custom-filter-mobile-style-outline", "tw-text-white");
  }

  filterMobileClick() {
    this.addEventListener("click", () => {
      this.removeClassName(document.querySelector(".custom-sort-by-filter-btn"));
      this.addClassName(document.querySelector(".custom-filter-mobile-style"));

      if (fetchedHtml) {
        this.addClassName(fetchedHtml.querySelector(".custom-filter-mobile-style"));
        this.removeClassName(fetchedHtml.querySelector(".custom-sort-by-filter-btn"));
      } else {
        this.addClassName(document.querySelector(".custom-filter-mobile-style"));
        this.removeClassName(document.querySelector(".custom-sort-by-filter-btn"));
      }
    });
  }
}

customElements.define("custom-filter-facet", CustomFilterFacet);
